import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../../const.js";

import InputFile from "../InputFile/InputFile";
import InputTextarea from "../InputTextarea/InputTextarea";
import InputCheckbox from "../InputCheckbox/InputCheckbox";

import PrewButton from "../PrewButton/PrewButton";
import FinishButton from "../FinishButton/FinishButton";

function Step3(props) {
  const {
    setStep,
    profession,
    setProfession,
    name,
    surname,
    patronymic,
    experience,
    birthDate,
    address,
    phone,
    job,
    email,
    participantPhoto,
    education,
    languages,

    excursionTitle,
    setExcursionTitle,
    excursionRoute,
    setExcursionRoute,
    excursionTargets,
    setExcursionTargets,
    excursionDuration,
    setExcursionDuration,
    excursionLength,
    setExcursionLength,
    shortDescription,
    setShortDescription,
    videoDescription,
    setVideoDescription,
    videoFragment,
    setVideoFragment,

    adminExperience,
    setAdminExperience,
    unionParticipation,
    setUnionParticipation,
    pastedСourses,
    setPastedСourses,
    selfPresentationVideo,
    setSelfPresentationVideo,
    esse,
    setEsse,

    agreement,
    setAgreement,
    dataAgreement,
  } = props;

  const [isFormFilled, setIsFormFilled] = useState(false);
  const [formErrors, setFormErrors] = useState(null);

  const submitHandler = (event) => {
    event.preventDefault();

    let url = "";
    let data;
    let additionalData;

    let generalData = {
      name: name,
      f_name: surname,
      middle_name: patronymic,
      work_experience: experience,
      date_of_birth: birthDate,
      address: address.value,
      place: job,
      email: email,
      phone: phone,
      photo_link: participantPhoto,
      education: education,
      lang: languages,
      personal_info: agreement,
      participation: dataAgreement,
    };

    if (profession === 1) {
      url = `${apiUrl}guide/`;
      additionalData = {
        excursion: excursionTitle,
        route: excursionRoute,
        points: excursionTargets,
        duration: excursionDuration,
        length: excursionLength,
        description: shortDescription,
        video_descr: videoDescription,
        video_fragment: videoFragment,
      };
    }

    if (profession === 2) {
      url = `${apiUrl}admin/`;

      additionalData = {
        experience: adminExperience,
        prof_org: unionParticipation,
        add_education: pastedСourses,
        video_descr: selfPresentationVideo,
        essay: esse,
      };
    }

    data = Object.assign(generalData, additionalData);

    axios
      .post(url, data)
      .then((res) => {
        setStep(4);
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setFormErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    if (profession === 1) {
      setIsFormFilled(
        excursionTitle &&
          excursionRoute &&
          excursionTargets &&
          excursionDuration &&
          excursionLength &&
          shortDescription &&
          videoDescription &&
          videoFragment &&
          agreement
      );
    }

    if (profession === 2) {
      setIsFormFilled(
        adminExperience &&
          unionParticipation &&
          pastedСourses &&
          selfPresentationVideo &&
          esse &&
          agreement
      );
    }
  }, [
    profession,
    excursionTitle,
    excursionRoute,
    excursionTargets,
    excursionDuration,
    excursionLength,
    shortDescription,
    videoDescription,
    videoFragment,
    adminExperience,
    unionParticipation,
    pastedСourses,
    selfPresentationVideo,
    esse,
    agreement,
  ]);

  useEffect(() => {
    if (formErrors) {
      const firstError = Object.keys(formErrors)[0];
      const firstErrorInput = document.querySelector(`[name=${firstError}]`);

      firstErrorInput.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  }, [formErrors]);

  return (
    <form action="." onSubmit={submitHandler}>
      {profession === 1 && (
        <div className="mm-form__inner">
          <InputTextarea
            title="Название и тема экскурсии *"
            placeholder="Текст"
            maxlength={3500}
            value={excursionTitle}
            onChange={setExcursionTitle}
            error={formErrors?.excursion}
            name="excursion"
          />
          <InputTextarea
            title="Маршрут пешеходной и/или автобусной экскурсии *"
            subTitle="Обязательно укажите место начала и завершения экскурсии"
            placeholder="Текст"
            maxlength={3500}
            value={excursionRoute}
            onChange={setExcursionRoute}
            error={formErrors?.route}
            name="route"
          />
          <InputTextarea
            title="Объекты показа на маршруте *"
            subTitle="Перечислите кратко"
            placeholder="Текст"
            maxlength={3500}
            value={excursionTargets}
            onChange={setExcursionTargets}
            error={formErrors?.points}
            name="points"
          />
          <InputTextarea
            title="Продолжительность *"
            subTitle="Не должна длиться более полутора часов"
            placeholder="Текст"
            maxlength={1500}
            value={excursionDuration}
            onChange={setExcursionDuration}
            error={formErrors?.duration}
            name="duration"
          />
          <InputTextarea
            title="Протяженность *"
            subTitle="Укажите в киллометрах. Не должна быть длиннее 2 киллометров."
            placeholder="Текст"
            maxlength={1500}
            value={excursionLength}
            onChange={setExcursionLength}
            error={formErrors?.length}
            name="length"
          />
          <InputTextarea
            title="Краткое описание/анонс *"
            subTitle="Объем текста не должен превышать 100 символов"
            placeholder="Текст"
            maxlength={100}
            value={shortDescription}
            onChange={setShortDescription}
            error={formErrors?.description}
            name="description"
          />
          <InputFile
            title="Видеоролик с описанием экскурсии и самопрезентацией *"
            subTitle="Вставьте ссылку на файлообменник. Длительность ролика - не более 1 минуты"
            placeholder="https://disk.yandex.ru/.."
            value={videoDescription}
            onChange={setVideoDescription}
            error={formErrors?.video_descr}
            name="video_descr"
          />
          <InputFile
            title="Видеоролик с фрагментом проведенной экскурсии *"
            subTitle="Вставьте ссылку на файлообменник. Длительность ролика - не более 3 минут"
            placeholder="https://disk.yandex.ru/.."
            value={videoFragment}
            onChange={setVideoFragment}
            error={formErrors?.video_fragment}
            name="video_fragment"
          />
        </div>
      )}

      {profession === 2 && (
        <div className="mm-form__inner">
          <InputTextarea
            title="Стаж работы по специальности «Администратор гостиницы» *"
            subTitle="Укажите название гостиницы, период работы и должность"
            placeholder="Текст"
            error={formErrors?.experience}
            value={adminExperience}
            onChange={setAdminExperience}
            name="experience"
          />
          <InputTextarea
            title="Участие в профсоюзной организации *"
            subTitle="Укажите название организации"
            placeholder="Текст"
            error={formErrors?.prof_org}
            value={unionParticipation}
            onChange={setUnionParticipation}
            name="prof_org"
          />
          <InputTextarea
            title="Пройденные образовательные курсы *"
            subTitle="Укажите пройденные образовательные курсы за последние 5 лет"
            placeholder="Текст"
            error={formErrors?.add_education}
            value={pastedСourses}
            onChange={setPastedСourses}
            name="add_education"
          />
          <InputFile
            title="Видеоролик с описанием и самопрезентацией *"
            subTitle="На тему «Ваш искренний сервис»: какие корпоративные и личные принципы, ценности гостеприимства вы применяете на своей работе? (длительность ролика — не более 3 минут, ролик должен быть снят на мобильный телефон или планшет) Вставьте ссылку на файлообменник"
            placeholder="https://disk.yandex.ru/.."
            error={formErrors?.video_descr}
            value={selfPresentationVideo}
            onChange={setSelfPresentationVideo}
            name="video_descr"
          />
          <InputTextarea
            title="Короткое эссе *"
            subTitle="На тему «Ваши личные секреты гостеприимства и предложения по улучшению качества обслуживания постояльцев в гостиницах Москвы"
            placeholder="Объем текста не должен превышать 600 слов"
            error={formErrors?.essay}
            value={esse}
            onChange={setEsse}
            name="essay"
          />
        </div>
      )}

      <div className="mm-form__inner">
        <InputCheckbox
          title="Подтверждаю свое согласие с <a href='./conditions.pdf' target='_blank'>Положением о проведении Конкурса</a>"
          value={agreement}
          onChange={setAgreement}
        />
      </div>

      <div className="buttons-wrapper">
        <PrewButton
          onClick={() => {
            setStep(2);
            setProfession(null);
          }}
        />
        <FinishButton disabled={!isFormFilled} />
      </div>
    </form>
  );
}

export default Step3;
